module.exports = __webpack_public_path__ + "static/media/8.404aa332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/8.jpg
// module id = 785
// module chunks = 0